// K11 (Finar 4.6) — dipnot numaralandırması grid satırlarına context ile iner: KpiGrid.tsx
// (≤600 satır) prop zinciri taşımaz; sayfa (KpiTablePage / PortalKpiTablePage) shared
// `numberGridFootnotes` sonucunu sağlar, KpiGridRow üst simgeyi, KpiFootnoteList listeyi çizer.
// Numara dizisi DOCX ve Excel ile aynıdır (aynı fonksiyon, aynı gösterge sırası).
import { createContext, useContext, useMemo } from "react";
import {
  numberGridFootnotes,
  type KpiFootnoteNumbering,
  type KpiResolvedGrid,
} from "@mahir/shared";

export const KpiFootnoteContext = createContext<KpiFootnoteNumbering | null>(null);

export function useKpiFootnotes(): KpiFootnoteNumbering | null {
  return useContext(KpiFootnoteContext);
}

/** Sayfa düzeyi: grid değişince yeniden numaralar (gösterge sırası = grid sırası, DOCX/Excel ile aynı). */
export function useGridFootnotes(grid: KpiResolvedGrid | null): KpiFootnoteNumbering | null {
  return useMemo(() => (grid ? numberGridFootnotes(grid) : null), [grid]);
}
